require('./loading');

let modals = require( './modals' );

let assign_delegates = ( function( $ ) {

	let $form,
		anim_speed = 300;

	let _init = function() {
		$form = $( '#assign-delegates' );

		if ( $form.length > 0 ) {
			_init_form();
		}
	};

	let _init_form = function() {
		_setup_select2();
		_attach_handlers();

		if ( $( '.delegate-select-wrap' ).length === $( '.delegate-select-wrap.assigned-delegate' ).length ) {
			_enable_continue();
		} else {
			_disable_continue();
		}
	};

	let _setup_select2 = function() {
		$( 'select.delegate-select' ).each( ( index, item ) => {
			$( item ).select2({
				dropdownParent: $( item ).closest( '.select-wrapper' )
			});
		} );
	};

	let _attach_handlers = function() {
		$( 'select.delegate-select' ).off( 'change', _change_delegate ).on( 'change', _change_delegate );
		$( 'a.remove-item' ).off( 'click', _remove_item ).on( 'click', _remove_item );

		$( 'a.remove-discount' ).not( '.setup' ).each( ( index, item ) => {
			$( item ).on( 'click', function( e ) {
				e.preventDefault();

				_remove_discount_code(  $( this ).data( 'code' ), $( this ).data( 'item-id' ) );
			} ) ;

			$( item ).addClass( 'setup' );
		} );

		$( 'a.toggle-discount-form' ).on( 'click', function( e ) {
			e.preventDefault();

			_toggle_discount_form( $( this ), $( this ).closest( '.delegate-select-wrap' ) );
		} );

		_setup_discount_forms();
	};

	let _setup_discount_forms = function() {
		$form.find( '.apply-discount-code' ).not( 'setup' ).each( ( index, item ) => {
			let $discount_form = $( item );

			$discount_form.find( '.button' ).on( 'click', ( e ) => {
				e.preventDefault();

				_submit_discount_form( $discount_form );
			} );

			$discount_form.addClass( 'setup' );
		} );
	};

	let _submit_discount_form = function( $discount_form ) {
		let item_id = $discount_form.data( 'item-id' ),
			code    = $discount_form.find( 'input.code-input' ).val();

		if ( ! code ) {
			_add_ticket_message( $( '#delegate-select-wrap-' + item_id ), 'Please enter a valid discount code', 'error' )
		} else {
			_apply_discount_code( item_id, code );
		}
	};

	let _apply_discount_code = function( item_id, code ) {
		$form.loading();

		let data = {
			action: 'crate_apply_discount_basket_item',
			nonce: ScriptData.apply_discount_basket_item_nonce,
			item: item_id,
			code: code
		};

		$.post( ScriptData.ajaxurl, data, ( response ) => {
			if ( response.success && response.html ) {
				_update_page_html( response.html );
			} else if ( response.error ){
				_add_ticket_message( $( '#delegate-select-wrap-' + item_id ), response.error, 'error' );
			} else if ( response.has_conditionals ) {
				$form.append( response.modal_html );
				_setup_discount_conditional_form();
			}

			$form.loaded();
		} )
	};

	let _setup_discount_conditional_form = function() {
		let $modal = $( '#discount-codes-conditional-checkboxes-modal' );

		$modal.find( 'form' ).on( 'submit', function( e ) {
			e.preventDefault();

			_submit_discount_conditional_form( $( this ) );
		} );

		modals.close_all_modals();
		modals.open_modal( $modal );
	};

	let _submit_discount_conditional_form = function( $conditional_form ) {
		$conditional_form.loading();

		let form_data = new FormData( $conditional_form.get( 0 ) ),
			data      = new FormData(),
			entries   = form_data.entries(),
			next;

		while ( ( next = entries.next() ) && next.done === false ) {
			data.append( 'form_data[' + next.value[ 0 ] + ']', next.value[ 1 ] );
		}

		data.append( 'action', 'crate_apply_discount_conditionals_basket_item' );
		data.append( 'nonce', ScriptData.apply_discount_conditionals_basket_item_nonce );
		data.append( 'item', $conditional_form.data( 'item-id' ) );
		data.append( 'code', $conditional_form.data( 'discount-code' ) );


		$.ajax( {
			type: 'POST',
			url: ScriptData.ajaxurl,
			data: data,
			success: _apply_discount_conditionals_response,
			processData: false,
			contentType: false,
		} );
	};

	let _apply_discount_conditionals_response = function( response ) {
		let $modal = $( '#discount-codes-conditional-checkboxes-modal' );

		if ( response.success ) {
			modals.close_all_modals();

			if ( response.html ) {
				_update_page_html( response.html );
			}

			setTimeout( () => {
				$modal.remove(); // Remove modal dom element after fade out
			}, 300 );
		}

		if ( ! response.success && response.error ) {
			_discount_conditional_form_notice( response.error, 'error' );

			$modal.find( 'form' ).loaded();
		}
	};

	let _discount_conditional_form_notice = function( message, type ) {
		_add_notice( $( '#discount-codes-conditional-checkboxes-modal .notices' ), message, type );
	};

	let _toggle_discount_form = function( $clicked_elem, $item_wrapper ) {
		let $discount_form = $item_wrapper.find( '.apply-discount-code' );

		if ( $discount_form.hasClass( 'animating' ) ) {
			return;
		}

		if ( $discount_form.hasClass( 'open' ) ) {
			$clicked_elem.text( $clicked_elem.data( 'open-text' ) );
			_close_discount_form( $discount_form );
		} else {
			$clicked_elem.text( $clicked_elem.data( 'close-text' ) );
			_open_discount_form( $discount_form );
		}

		$discount_form.addClass( 'animating' );

		setTimeout( () => {
			$discount_form.removeClass( 'animating' );
		}, anim_speed );
	};

	let _open_discount_form = function( $discount_form ) {
		$discount_form.removeClass( 'closed' );
		$discount_form.addClass( 'open' );
		$discount_form.slideDown( anim_speed );

		$discount_form.find( 'input.code-input' ).focus();
	};

	let _close_discount_form = function( $discount_form ) {
		$discount_form.removeClass( 'open' );
		$discount_form.addClass( 'closed' );
		$discount_form.slideUp( anim_speed );
	};

	let _remove_discount_code = function( code, item_id ) {
		$form.loading();

		let data = {
			action: 'crate_remove_discount_basket_item',
			nonce: ScriptData.remove_discount_basket_item_nonce,
			item: item_id,
			code: code,
		};

		$.post( ScriptData.ajaxurl, data, ( response ) => {
			if ( response.success && response.html ) {
				_update_page_html( response.html );
			}

			$form.loaded();
		} );
	};

	let _change_delegate = function( e ) {
		$form.loading();

		let data = {
			action: 'crate_update_delegate_basket_item',
			nonce: ScriptData.update_delegate_basket_item_nonce,
			item : $( this ).data( 'id' ),
			delegate: $( this ).val()
		};

		$.post( ScriptData.ajaxurl, data, _change_delegate_response );
	};

	let _change_delegate_response = function( response ) {
		let $ticket_wrapper = $( '#delegate-select-wrap-' + response.item );

		if ( response.success ) {
			if ( response.delegate ) {
				$ticket_wrapper.addClass( 'assigned-delegate' );
			} else {
				$ticket_wrapper.removeClass( 'assigned-delegate' );
			}
		} else if ( ! response.success ) {

			if ( ! response.ready_for_purchase ) { // Can still be assigned to a delegate
				$ticket_wrapper.removeClass( 'assigned-delegate' );
			}

			if ( response.error ) {
				_add_ticket_message( $ticket_wrapper, response.error, 'error' );
			}
		}

		if ( response.ready_for_purchase ) {
			_enable_continue();
		} else {
			_disable_continue();
		}

		$form.loaded();
	};

	let _remove_item = function( e ) {
		e.preventDefault();
		e.stopImmediatePropagation();

		$form.loading();

		let data = {
			action: 'crate_remove_item_basket_item',
			nonce: ScriptData.remove_item_basket_item_nonce,
			item: $( this ).data( 'id' ),
		};

		$.post( ScriptData.ajaxurl, data, _remove_item_response );

	};

	let _remove_item_response = function( response ) {
		if ( response.redirect ) {
			window.location.href = response.redirect;
			return;
		}

		if ( response.success && response.html ) {
			_update_page_html( response.html );
			return;
		}

		if ( response.error ) {
			_add_ticket_message( $( '#delegate-select-wrap-' + response.item ), response.error, 'error' );
		}

		$form.loaded();
	};

	let _enable_continue = function() {
		$( '#continue-button' ).removeClass( 'disabled' ).off( 'click' );
	};

	let _disable_continue = function() {
		$( '#continue-button' ).addClass( 'disabled' ).on( 'click', ( e ) => {
			e.preventDefault();
		} );
	};

	let _update_page_html = function( html ) {
		$form.replaceWith( html );

		$form = $( '#assign-delegates' );
		$form.loading();

		_init_form();

		$form.loaded();
	};

	let _add_ticket_message = function( $ticket_wrapper, message, type ) {
		_add_notice( $ticket_wrapper.find( '.notices' ), message, type );
	};

	let _add_notice = function( $wrapper, message, type ) {
		$wrapper.find( '.notice' ).not( '.current-notice' ).slideUp( 300 );
		$wrapper.prepend( '<div class="crate-notice current-notice notice ' + type + '" style="display: none">' + message + '</div>' );

		let $current_notice = $wrapper.find( '.current-notice' );

		$current_notice.slideDown( anim_speed ).removeClass( 'current-notice' );

		setTimeout( () => {
			$current_notice.slideUp( anim_speed );
			setTimeout( () => {
				$current_notice.remove();
			}, anim_speed );
		}, 5000 );
	};

	$( document ).ready( _init );

} )( jQuery );

module.exports = assign_delegates;